import React, { useState } from 'react';
import BusinessIcon from '@material-ui/icons/Business';
import Paper from '@material-ui/core/Paper';

import moment from 'moment';

import { useStyles } from './styles';

const FormFirmHeader = React.memo(
    ({ formId, firmName, dueDate }: { formId: string; firmName: string; dueDate: string }) => {
        const classes = useStyles();
        const date = moment(dueDate).format('MM-DD-YYYY');
        const [imgError, setImgError] = useState(false);
        const imgUrl = formId
            ? `api/form/${formId}/logo`
            : '/api/firmInfo/logo?' + new Date().getTime();

        return (
            <div>
                <Paper classes={{ root: classes.formHeaderRoot }} elevation={0}>
                    <div className={classes.themeStripe} />
                    <div className={classes.firmHeaderContainer}>
                        {!imgError && (
                            <img
                                src={imgUrl}
                                alt="Firm Logo"
                                width="60px"
                                height="60px"
                                onError={() => setImgError(true)}
                            />
                        )}
                        {imgError && <BusinessIcon />}
                        <div className={classes.formHeaderContent}>
                            <div className={classes.firmName}>{firmName}</div>
                            <div className={classes.firmDescription}>
                                <p>Please complete and submit the following form by {date}</p>
                                <p>Required fields are marked with *</p>
                            </div>
                        </div>
                    </div>
                </Paper>
            </div>
        );
    },
);

export default FormFirmHeader;
